import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-time-roll-san-form',
  templateUrl: './time-roll-san-form.component.html',
  styleUrls: ['./time-roll-san-form.component.css']
})
export class TimeRollSanFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Attendance-Leaves/time-roll-sanctions/time-roll-san-form/time-roll-san-form.component.ts